import { render } from "./SectionsSubMenu.vue?vue&type=template&id=94d48cda"
import script from "./SectionsSubMenu.vue?vue&type=script&lang=js"
export * from "./SectionsSubMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__